import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahilyanagarcabs() {



  const cardData =
  {
    keyword: 'Pune to Ahilyanagar Cabs',
    heading: 'Sai Trupti Cabs: Pune to Ahilyanagar Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Ahilyanagar cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Ahilyanagar. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Ahilyanagar convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Ahilyanagar with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort stands as a symbol of courage, resilience, and strategic brilliance in Maharashtra’s history. Built in the early 15th century by Malik Ahmad Nizam Shah, this circular stone fortress with deep moats and bastions became a stronghold of the Nizam Shahi dynasty. The fort later gained prominence during India’s freedom struggle when Pandit Jawaharlal Nehru was imprisoned here, where he wrote his famous book 'The Discovery of India'. Today, the fort’s walls echo both royal grandeur and patriotic pride. Its panoramic view, medieval architecture, and historical aura make it a must-visit landmark of Ahilyanagar."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Located near Ahilyanagar, Shirdi Sai Baba Temple is one of India’s most visited pilgrimage centers, drawing millions of devotees every year. The temple complex revolves around the Samadhi Mandir, where the sacred remains of Sai Baba rest. The air resonates with the chants of 'Sai Ram' and the fragrance of incense. Devotees experience deep peace as they witness the aarti and darshan. Surrounding attractions like Dwarkamai, Chavadi, and Lendi Baug preserve the saint’s legacy of love and simplicity. A visit to Shirdi offers not just spiritual solace but also a profound reminder of faith and humanity’s shared divinity."
  },
  {
    "title": "Meherabad (Meher Baba Ashram)",
    "description": "Meherabad, near Ahmednagar city, is the spiritual retreat and resting place of Meher Baba — revered globally as the 'Avatar of the Age'. Set amidst serene countryside, the ashram invites visitors from around the world to meditate and experience peace. The Samadhi (Tomb Shrine) of Meher Baba is the focal point, surrounded by tranquil gardens, prayer halls, and accommodations for pilgrims. The annual Amartithi festival draws thousands in quiet devotion. Meherabad’s stillness, simplicity, and universality make it a haven for seekers searching for divine truth beyond religion or boundaries."
  },
  {
    "title": "Ralegan Siddhi",
    "description": "Ralegan Siddhi, the model village of India, is an inspiring testament to sustainable living and social transformation. Led by social reformer Anna Hazare, the village transformed from a drought-prone region into a green, self-sufficient community through water conservation and cooperative spirit. Visitors can explore the check dams, solar panels, and eco-friendly farms that reflect the village’s progressive ethos. Ralegan Siddhi stands as a living classroom of rural development, harmony, and environmental awareness. It’s not just a place to visit — it’s a place to learn how collective determination can change lives."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Shani Shingnapur, located about 35 km from Ahilyanagar, is a unique temple dedicated to Lord Shani (Saturn). The temple is famous for its open-air idol — a black stone standing under the sky without any roof — symbolizing Lord Shani’s omnipresence. The village is known for its houses without doors, built on faith that Lord Shani protects all devotees from harm. The atmosphere hums with devotion as pilgrims perform oil rituals and prayers. The temple embodies purity, honesty, and divine protection, attracting devotees from across India seeking relief from planetary afflictions and inner peace."
  },
  {
    "title": "Tank Museum (Cavalry Tank Museum)",
    "description": "The Cavalry Tank Museum in Ahmednagar is India’s only museum dedicated to armored vehicles and military history. Established in 1994 by the Armored Corps Centre, it displays over 50 tanks, armored cars, and war relics from around the world — including models from World War I and II. Each tank tells a story of bravery, engineering, and warfare evolution. The open-air display grounds, detailed exhibits, and guided tours offer a fascinating experience for defense enthusiasts and families alike. It’s a proud salute to the Indian Army’s valor and technological prowess, making it a standout attraction in Ahilyanagar."
  },
  {
    "title": "Rehekuri Blackbuck Sanctuary",
    "description": "Rehekuri Blackbuck Sanctuary, located about 80 km from Ahmednagar, is a paradise for wildlife enthusiasts. Spread over 2 square kilometers, it is home to more than 500 blackbucks, along with chinkaras, foxes, and diverse bird species. Visitors can enjoy safaris through grasslands dotted with acacia trees and open skies. The sight of graceful blackbucks leaping across the plains at sunrise is unforgettable. The sanctuary promotes eco-tourism and wildlife preservation, offering an ideal retreat for photographers and nature lovers. Rehekuri showcases Maharashtra’s ecological beauty and Ahilyanagar’s quiet commitment to conservation."
  },
  {
    "title": "Farah Bagh Palace",
    "description": "Farah Bagh Palace, once a luxurious pleasure retreat of the Nizam Shah rulers, now stands in poetic ruins near Ahmednagar city. Built in the 16th century, this circular palace was surrounded by lush gardens and water channels fed by the nearby Bhingar River. The structure once hosted royal gatherings, music, and Persian poetry under the open sky. Today, its weathered stones whisper stories of forgotten grandeur and Mughal influence. Set amid tranquil countryside, Farah Bagh offers visitors a nostalgic glimpse into Ahilyanagar’s regal past and the fading beauty of medieval architecture."
  },
  {
    "title": "Avhane Village (Jain Temples)",
    "description": "Avhane Village, located 30 km from Ahmednagar, is a sacred site for the Jain community, known for its ancient Digambar Jain temples. The temples feature exquisite stone carvings, serene idols, and architectural details reminiscent of medieval craftsmanship. The peaceful surroundings and devotional ambiance make it a perfect destination for spiritual seekers. Annual fairs and rituals bring the village alive with faith and festivity. Avhane represents Ahilyanagar’s hidden spiritual side — where devotion blends seamlessly with art, silence, and timeless heritage."
  },
  {
    "title": "Bhinar Fort (Bhingar Fort)",
    "description": "Bhinar Fort, also known as Bhingar Fort, is one of Ahmednagar’s oldest strongholds, offering panoramic views of the surrounding plains. Believed to predate the Ahmednagar Fort, it played a crucial role in early Deccan defense systems. The fort’s ancient walls, gateways, and watchtowers tell tales of strategy and valor. Trekkers and history lovers enjoy exploring its rugged terrain and scenic backdrop. Though partially in ruins, Bhinar Fort retains a raw, unfiltered beauty that captures the essence of Maharashtra’s enduring warrior heritage."
  }
],



"services": [
  {
    "name": "Pune to Ahilyanagar Cabs",
    "description": "Book comfortable Pune to Ahilyanagar cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Ahilyanagar Taxi Service",
    "description": "Hire a Pune to Ahilyanagar taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Ahilyanagar Car Hire",
    "description": "Rent a car from Pune to Ahilyanagar for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Ahilyanagar",
    "description": "Travel comfortably with AC cab service from Pune to Ahilyanagar. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Ahilyanagar",
    "description": "Affordable non-AC cab service from Pune to Ahilyanagar for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Ahilyanagar",
    "description": "Book spacious and comfortable Innova cabs from Pune to Ahilyanagar. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Ahilyanagar",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Ahilyanagar. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Ahilyanagar",
    "description": "Travel in style with luxury cab services from Pune to Ahilyanagar. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Ahilyanagar",
    "description": "Get pocket-friendly Pune to Ahilyanagar cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Ahilyanagar Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Ahilyanagar ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Ahilyanagar One Way Cab",
    "description": "Book one-way cabs from Pune to Ahilyanagar at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Ahilyanagar without return plans."
  },
  {
    "name": "Pune to Ahilyanagar Drop Cab",
    "description": "One-way drop cab service from Pune to Ahilyanagar with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Ahilyanagar",
    "description": "Premium corporate cab hire from Pune to Ahilyanagar with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Ahilyanagar",
    "description": "Elegant wedding cab service from Pune to Ahilyanagar with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Ahilyanagar",
    "description": "Book your Pune to Ahilyanagar cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Ahilyanagar Cabs", "Pune to Ahilyanagar Taxi Service"],
  ["Pune to Ahilyanagar Car Hire", "AC Cab Pune to Ahilyanagar"],
  ["Non AC Cab Pune to Ahilyanagar", "Innova Cab Pune to Ahilyanagar"],
  ["Ertiga Cab Pune to Ahilyanagar", "Luxury Cab Pune to Ahilyanagar"],
  ["Affordable Cab Pune to Ahilyanagar", "Pune to Ahilyanagar Outstation Cab"],
  ["Pune to Ahilyanagar One Way Cab", "Pune to Ahilyanagar Drop Cab"],
  ["Online Cab Booking Pune to Ahilyanagar", "Corporate Cab Pune to Ahilyanagar"],
  ["Wedding Cab Pune to Ahilyanagar", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ahilyanagar Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and reliable cab services from Pune to Ahilyanagar (Ahmednagar) — perfect for family travel, temple visits, business trips, and leisure journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Ahilyanagar cabs — no hidden costs, no surge pricing, and full value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your comfort, group size, and budget for the Pune–Ahilyanagar route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with the Pune to Ahilyanagar route, ensuring a safe, smooth, and punctual travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune — airport, home, or office — and drop-offs at your desired location in Ahilyanagar."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains a fleet of clean, sanitized, and regularly serviced vehicles to ensure a comfortable and reliable ride every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist you with booking, queries, or route details for your Pune to Ahilyanagar trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Ahilyanagar cab easily via call, WhatsApp, or our website — get instant booking confirmation and timely cab service."
  }
]
























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Ahilyanagar cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Ahilyanagar cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Ahilyanagar cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Ahilyanagar cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Ahilyanagar?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Ahilyanagar routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Ahilyanagar route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Ahilyanagar?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Ahilyanagar for popular attractions like Ahmednagar Fort, Cavalry Tank Museum, and Meherabad.',
  },
  {
    question: 'Is the Pune to Ahilyanagar cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Ahilyanagar cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Ahilyanagar cab fares?',
    answer: 'Our Pune to Ahilyanagar cab fares start from ₹2,000 for sedans and ₹2,800–₹3,500 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Ahilyanagar cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Ahilyanagar cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Ahilyanagar cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Ahilyanagar trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vishal Pawar',
    feedback: 'Had a smooth and comfortable trip from Pune to Ahilyanagar with Sai Trupti Cabs. The car was clean and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kavita Shinde',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Ahilyanagar journey. On-time pickup, safe driving, and great comfort throughout!',
    rating: 5,
  },
];

























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];

















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Ahilyanagar Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-to-ahilyanagar-cab.jpg", // Replace with actual image URL
  "description": "Book cabs from Pune to Ahilyanagar with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500", // Example price, adjust according to actual rates
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-ahilyanagar-cab-booking"
  }
};




  return (
    <div>
<Helmet>
  <title>Pune to Ahilyanagar Cabs | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Ahilyanagar with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Pune to Ahilyanagar Cabs, Pune to Ahilyanagar Taxi Service, Pune to Ahilyanagar Car Hire, AC Cab Pune to Ahilyanagar, Non AC Cab Pune to Ahilyanagar, Innova Cab Pune to Ahilyanagar, Ertiga Cab Pune to Ahilyanagar, Luxury Cab Pune to Ahilyanagar, Affordable Cab Pune to Ahilyanagar, Pune to Ahilyanagar Outstation Cab, Pune to Ahilyanagar One Way Cab, Pune to Ahilyanagar Drop Cab, Corporate Cab Pune to Ahilyanagar, Wedding Cab Pune to Ahilyanagar, Online Cab Booking Pune to Ahilyanagar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoahilyanagarcabs;